import React from 'react';
import Img from 'gatsby-image';
import { BooksProps } from 'models/BooksProps';
import * as Styled from './BacgroundImageStyles';

const BackgroundImage: React.FC<BooksProps> = ({ books, selectedIndex }) => {
  return (
    <>
      {books.map((book, index: number) => {
        const { fluid } = book.background_image.localFile.childImageSharp;

        let isSelected = index === selectedIndex;
        return (
          <Styled.BgImage key={index} animate={isSelected ? 'visible' : 'hidden'}>
            <Img fluid={fluid} />
          </Styled.BgImage>
        );
      })}
    </>
  );
};

export default BackgroundImage;
